import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { IMovies } from "../../models/IMovies";
import { IMovieQuery } from "../../models/IMovieQuery";

export const movieApi = createApi({
  reducerPath: "movieApi",
  baseQuery: fetchBaseQuery({ baseUrl: "https://cinemaguide.skillbox.cc" }),
  endpoints: (build) => ({
    getRandomMovie: build.query<IMovies, string>({
      query: (url) => ({
        url: url,
        providesTags: ["movieApi"],
      }),
    }),
    getTopMovies: build.query<IMovies[] | undefined, number>({
      query: (count) => ({
        url: `/movie/top10`,
        params: {
          _count: count,
        },
        providesTags: ["movieApi"],
      }),
    }),
    getMovies: build.query<IMovies[], IMovieQuery>({
      query: ({count, genre, page, title}) => ({
        url: `movie`,
        params: {
          page: page,
          title: title,
          count: count,
          genre: genre,
        },
        providesTags: ["movieApi"],
      }),
    }),
    fetchIdMovie: build.query<IMovies, number | undefined>({
      query: (id) => ({
        url: `/movie/${id}`,
        providesTags: ["movieApi"],
      }),
    }),
    getGanreMovie: build.query<string[], string>({
      query: (url) => ({
        url: url,
        providesTags: ["movieApi"],
      }),
    }),
  }),
});
